import type { SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './lib/database.types';

type SignOutScope = 'global' | 'local' | 'others';

/**
 * Sign out the current browser session.
 *
 * Defaults to `local` scope (clear this tab only). Global revocation often
 * returns 403 when the app runs on a custom domain and Supabase Auth cookies
 * on *.supabase.co are treated as third-party.
 */
export async function signOutSafely(
  client: SupabaseClient<Database>,
  options?: { scope?: SignOutScope },
): Promise<void> {
  const scope = options?.scope ?? 'local';
  const { error } = await client.auth.signOut({ scope });
  if (!error) return;

  if (scope !== 'local') {
    const { error: localError } = await client.auth.signOut({ scope: 'local' });
    if (!localError) return;
    throw localError;
  }

  throw error;
}
